module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 480\" version=\"1\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\" transform=\"scale(1.25 .9375)\"><rect rx=\"0\" ry=\"0\" height=\"509.76\" width=\"512\" fill=\"#fff\"/><rect rx=\"0\" ry=\"0\" height=\"169.92\" width=\"512\" y=\"342.08\" fill=\"#21468b\"/><path fill=\"#ae1c28\" d=\"M0 0h512v169.92H0z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/nl.svg
// module id = 54
// module chunks = 0